export default __webpack_public_path__ + "static/media/Figure-4.f21311f6.jpg";